/*
 * view for the body of a sortable list
 */

define([
  "marionette",
  "underscore",
  "jquery",
  "messaging/messenger",
  "i18n/i18n",
  "bootstrap",
  "jquery-ui",
  "jquery-ui/ui/widgets/draggable",
  "jquery-ui/ui/widgets/droppable",
], function (Marionette, _, $, Messenger) {
  "use strict";

  const SortableListBodyView = {};

  SortableListBodyView.sortableListBodyItemView = Marionette.ItemView.extend({
    tagName: "tr",
    initialize: function (options) {
      //console.log("In sortable list body view");
      //extend the events of this view with any user defined events
      if (options.extendedEvents) {
        this.events = _.extend(this.events, options.extendedEvents);
      }
      if (typeof this.model.filteredOut === "undefined") {
        this.model.filteredOut = false;
      }
      if (typeof this.model.checked === "undefined") {
        this.model.checked = false;
      }
      this.headers = options.headers;
      //build template out of header attributes
      this.template = ""; //clear out template (doesn't seem necessary, but better safe than sorry)
      //only show model if it's not filtered out and on the current page (if pagination is enabled)
      for (let i = 0; i < this.headers.length; i++) {
        if (!this.headers.at(i).get("hidden")) {
          if (this.headers.at(i).get("checkbox")) {
            //create checkbox, either checked or unchecked depending on the model.checked variable
            this.template +=
              '<% if (!_thisObject.checked) { %> <td><i id="checkbox" class="icon-check-empty"></i></td>';
            this.template +=
              ' <% } else { %> <td><i id="checkbox" class="icon-check"></i></td> <% } %>';
          } else if (this.headers.at(i).get("arrayField")) {
            //create a list if the array is greater than 1
            const arrayAttribute = this.headers.at(i).get("modelAttribute");
            this.template += "<td><% if (" + arrayAttribute + ".length > 1) { %><ul>";
            this.template +=
              "<% _.each(" +
              arrayAttribute +
              ", function(element) { %><li><%- element %></li><% }); %></ul>";
            this.template += "<% } else if (" + arrayAttribute + ".length > 0) { %>";
            this.template += "<%- " + arrayAttribute + "[0] %> <% } %></td>";
          } else if (this.headers.at(i).get("customHtml")) {
            //embed custom html into the row
            let customHtml = this.headers.at(i).get("customHtml");
            if (_.isFunction(customHtml)) {
              customHtml = customHtml(this.model);
            }
            this.template += "<td>" + customHtml + "</td>";
          } else if (this.headers.at(i).get("dateField")) {
            let localDate;
            if (this.headers.at(i).get("dateOnly")) {
              localDate = Messenger.reqres.request(
                "get:formatted:date:long",
                this.model.get(this.headers.at(i).get("modelAttribute")),
              );
            } else {
              localDate = Messenger.reqres.request(
                "get:formatted:dateTime",
                this.model.get(this.headers.at(i).get("modelAttribute")),
              );
            }
            this.template += "<td>" + localDate + "</td>";
          } else if (this.headers.at(i).get("durationField")) {
            const localDuration = Messenger.reqres.request(
              "get:formatted:durationSeconds",
              this.model.get(this.headers.at(i).get("modelAttribute")),
            );
            this.template += "<td>" + localDuration + "</td>";
          } else if (this.headers.at(i).get("durationMillisecondsField")) {
            const localMillisecondDuration = Messenger.reqres.request(
              "get:formatted:durationMilliseconds",
              this.model.get(this.headers.at(i).get("modelAttribute")),
            );
            this.template += "<td>" + localMillisecondDuration + "</td>";
          } else if (this.headers.at(i).get("booleanField")) {
            if (this.headers.at(i).get("booleanFieldCheck")) {
              this.template +=
                "<td>" +
                "<% if (" +
                this.headers.at(i).get("modelAttribute") +
                ") { %>" +
                '<i class="icon-check"></i>' +
                "<% } %>" +
                "</td>";
            } else {
              this.template +=
                "<td>" +
                "<% if (" +
                this.headers.at(i).get("modelAttribute") +
                ") { %>" +
                '<span data-i18n="common.yes"></span>' +
                "<% } else { %>" +
                '<span data-i18n="common.no"></span>' +
                "<% } %>" +
                "</td>";
            }
          } else {
            let field;
            if (this.headers.at(i).get("selectable")) {
              //make td a selectable link
              if (this.headers.at(i).get("escapeHTML") !== false) {
                field =
                  "<a href=# id=selectableField>" +
                  "<%- " +
                  this.headers.at(i).get("modelAttribute") +
                  " %>" +
                  "</a>";
              } else {
                // This is specifically marked as needing to allow HTML, so do not escape
                field =
                  "<a href=# id=selectableField>" +
                  "<%= " +
                  this.headers.at(i).get("modelAttribute") +
                  " %>" +
                  "</a>";
              }
            } else {
              if (this.headers.at(i).get("escapeHTML") !== false) {
                field = "<%- " + this.headers.at(i).get("modelAttribute") + " %>";
              } else {
                // This is specifically marked as needing to allow HTML, so do not escape
                field = "<%= " + this.headers.at(i).get("modelAttribute") + " %>";
              }
            }
            if (this.headers.at(i).get("editable")) {
              //set up this.textboxes
              this.textboxes = {
                "span.editable": {
                  doNotModifyPlaceholder: this.headers.at(i).get("doNotModifyPlaceholder"),
                  enableSelector: "span.editable",
                  modelAttribute: this.headers.at(i).get("modelAttribute"),
                  placeholder:
                    this.headers.at(i).get("placeholder") || this.headers.at(i).get("headerName"),
                  textArea: false,
                },
              };
              this.template += '<td><span class="editable"></span></td>';
            } else if (this.headers.at(i).get("droppable")) {
              this.template += "<td class='droppable'>" + field + "</td>";
            } else if (this.headers.at(i).get("draggable")) {
              this.template += "<td class='draggable'>" + field + "</td>";
            } else {
              this.template += "<td>" + field + "</td>";
            }
          }
        }
      }
      this.options = options;
    },
    events: {
      "click #checkbox": function () {
        //allow click event to propagate
        this.trigger("toggle:checkbox");
      },
    },
    modelEvents: {
      change: "render",
      enter: "render", //catch textbox changes
    },
    onRender: function () {
      //console.log("On render");
      this.$el.i18n();
      this.$el
        .find('a[data-toggle="tooltip"], button[data-toggle="tooltip"]')
        .tooltip({ delay: { show: 333, hide: 0 }, container: "body" });
      //apply textboxes defined in this.textboxes
      this._applyTextboxes();
      const _this = this;

      //drag support
      this.$el.find(".droppable").droppable({
        addClasses: false,
        activeClass: "droppable-active",
        hoverClass: "droppable-hover",
        tolerance: "pointer",
        drop: function () {
          //make sure the middle of the target for the drop is actually visible and not hidden in the overflow
          const droppableMiddle = $(this).position().top + $(this).outerHeight() / 2;
          const sortableListBody = $("#sortableListBody > div");
          const listTop = sortableListBody.position().top;
          const listBottom = sortableListBody.position().top + sortableListBody.height();
          //console.log("top: " + droppableMiddle + " > " + listTop);
          //console.log("bottom:" + droppableMiddle + " < " + listBottom);
          if (droppableMiddle < listBottom && droppableMiddle > listTop) {
            _this.trigger("model:dropped", _this);
          }
        },
      });

      //drop support
      this.$el.find(".draggable").draggable({
        addClasses: false,
        appendTo: "body",
        distance: 20,
        opacity: 0.9,
        helper: "clone",
        cursor: "move",
        containment: "#main",
        cursorAt: { left: 0, top: 0 },
        start: function (event, ui) {
          //change style of the cloned draggable object
          $(ui.helper).addClass("draggable-active");
          _this.trigger("dragged:item");
        },
      });
    },
    triggers: {
      "click #selectableField": "selected:row",
    },
  });

  // noinspection JSUnusedGlobalSymbols
  SortableListBodyView.sortableListBodyView = Marionette.CollectionView.extend({
    itemView: SortableListBodyView.sortableListBodyItemView,
    tagName: "tbody",
    initialize: function (options = {}) {
      this.extendedEvents = options.extendedEvents;
      this.headers = options.headers;
      this.paginationFilter = options.paginationFilter;
    },
    itemViewOptions: function () {
      //pass header objects to ItemView
      return {
        headers: this.headers,
        extendedEvents: this.extendedEvents, //pass extended events hash to extend the events of each itemView
      };
    },
    collectionEvents: {
      sort: "render",
      remove: "render",
      //shortcut to remove a bunch of models without rerendering during each model's removal
      removeMultiple: "render",
      filter: "render",
      sync: "render",
    },
    // Internal method to loop through each item in the
    // collection view and show it.
    // Modified to only add itemViews that will be shown
    showCollection: function () {
      let ItemView;
      let indexCount = 0;

      this.collection.each(function (item, index) {
        let showModel;
        if (item.filteredOut || item.hideModel) {
          showModel = false; //don't show filtered out models
        } else {
          if (this.paginationFilter) {
            showModel = this.paginationFilter(indexCount);
          } else {
            showModel = true; //if no pagination, show all non-filtered models
          }
          indexCount++;
        }
        if (showModel) {
          ItemView = this.getItemView(item);
          this.addItemView(item, ItemView, index);
        }
      }, this);
    },
  });

  return SortableListBodyView;
});
